import React from "react";
import { observer } from "mobx-react-lite";
import { useWindowDimensions } from "@lib-shared/hooks";
import UserActivityLogStore from "core/stores/user-activity-logger.store";
import { fields, logName } from "core/stores/user-activity-logger.store.manager";

type ItemRowsProps = {
    toggleSort: any;
    store: UserActivityLogStore;
}

type SortableHeaderProps = {
    field: string;
    name: string;
    cssName?: string;
}

const ItemRows = observer((props: ItemRowsProps) => {
    const { toggleSort, store } = props;
    const dimensions = useWindowDimensions();

    const SortableHeader = (headerProps: SortableHeaderProps) => {
        const { field, name, cssName = "" } = headerProps;

        return (
            <th className={`sortable ${cssName}`} onClick={(e) => toggleSort(field)} title={`Sort by ${name}`}>
                {name}
                {store.sorting.field === field
                    ? <i className={store.sorting.direction === "asc"
                        ? "icon-Dropdown_up"
                        : "icon-Dropdown_down"} />
                    : null}
            </th>
        );
    }

    if (store.pageItems.length === 0) {
        return (
            <p>There are no logs that match your criteria.</p>
        )
    }

    const columnTitle = dimensions.width <= 767 ? "Date" : "Date and Time";

    return (
        <table className="user-activity-logs">
            <thead>
                <tr>
                    <SortableHeader field={fields.dateTime} name={columnTitle} />
                    <SortableHeader field={fields.name} name="Name" />
                    <SortableHeader field={fields.userType} name="User Type" cssName="user-type" />
                    <SortableHeader field={fields.action} name="Action" />
                </tr>
            </thead>
            <tbody>
                {store.pageItems.map((log, index) => {
                    return (
                        <tr key={log.index}>
                            <td className="date">
                                {log.date} <span className="time">{log.time}</span>
                            </td>
                            <td>
                                <span className="name">{logName(log)}</span>
                            </td>
                            <td className="user-type">{log.userType}</td>
                            <td>{log.description}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
});

export default ItemRows;
